import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HelpHubPage from '@/features/help/HelpHubPage';
import HelpFaqPage from '@/features/help/HelpFaqPage';
import HelpFaqArticlePage from '@/features/help/HelpFaqArticlePage';

const HelpRoutes = () => (
  <Routes>
    <Route index element={<HelpHubPage />} />
    <Route path="faq" element={<HelpFaqPage />} />
    <Route path="faq/:slug" element={<HelpFaqArticlePage />} />
  </Routes>
);

export default HelpRoutes;
